import type { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Button, Sizes, Tooltip } from '@dbt-labs/sourdough';

import { ToolbarItem } from '../dag/DagInterfaces';

interface DagToolbarProps {
  toolbarItems: ToolbarItem[];
}

export const DagToolbar = ({ toolbarItems }: DagToolbarProps): JSX.Element | null => {
  if (!toolbarItems || !toolbarItems.length) {
    return null;
  }

  const buildButton = (toolbarItem: ToolbarItem) => {
    return (
      <Tooltip
        key={toolbarItem.tooltip}
        content={toolbarItem.tooltip}
        placement="bottom"
        portal
      >
        <Button
          type="secondary"
          className={twMerge(
            'pointer-events-auto truncate whitespace-nowrap border-borderDisabled dark:border-borderMain',
            toolbarItem.className,
          )}
          text={toolbarItem.label}
          size={Sizes.sm}
          ryecon={toolbarItem.ryecon}
          iconPlacement="left"
          isDisabled={toolbarItem.isDisabled}
          onClick={toolbarItem.action}
          testId={toolbarItem.testId}
          aria-label={toolbarItem.label || toolbarItem.tooltip}
        />
      </Tooltip>
    );
  };

  return (
    <div className={`absolute right-6 top-6 flex gap-2 rounded bg-opacity-50`}>
      {toolbarItems.map((item: ToolbarItem) => buildButton(item))}
    </div>
  );
};
